import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import useCustomEffect from "../../../../hooks/useCustomEffect";
import HouserulesStepView from "./HouseruleStepView";

function HouserulesStep({ controller }) {
  const callEvaApi = useEvaApi();
  const fetchedHouseruleData =
    controller.visitorData[`fetched_houserules_${controller.step.file.id}`];
  const houseruleData =
    controller.visitorData[`houserules_${controller.step.file.id}`];
  const accepted =
    houseruleData === undefined ? fetchedHouseruleData : houseruleData;
  const [read, setRead] = useState(
    houseruleData || fetchedHouseruleData || false,
  );

  // UseEffect for fetching if the houserule was accepted
  useCustomEffect(() => {
    fetchAccepted();
  });

  /**
   * This method will handle the read event
   */
  function onRead() {
    setRead(true);
    if (fetchedHouseruleData && houseruleData === undefined) {
      onAcceptChange(true);
    }
  }

  /**
   * This method will handle the accept change event
   * @param {bool} value
   */
  function onAcceptChange(value) {
    controller.setVisitorData((prevData) => ({
      ...prevData,
      [`houserules_${controller.step.file.id}`]: value,
    }));
  }

  /**
   * This method will fetch if the houserule was accepted
   */
  async function fetchAccepted() {
    if (houseruleData || fetchedHouseruleData) return;

    await callEvaApi(
      new EvaApiCall("visitors/accepted/houserules")
        .setLoadingGroup("flow_player_next_step")
        .setParams({
          ...controller.visitorData,
          flow_step_id: controller.step.id,
        })
        .setAlertError(false)
        .setAlertSuccess(false)
        .setOnSuccess((response) => {
          const accepted = response.data.data.accepted;
          if (!accepted) return;

          controller.setVisitorData((prevData) => ({
            ...prevData,
            [`fetched_houserules_${controller.step.file.id}`]: true,
          }));

          onRead();
        }),
    );
  }

  return (
    <HouserulesStepView
      controller={controller}
      read={read}
      accepted={accepted}
      onRead={onRead}
      onAcceptChange={onAcceptChange}
    />
  );
}

export default HouserulesStep;
